const appExclusiveSkus = {
  // Test SKU
  '3063037':
    'https://argos.onelink.me/ID6P?af_xp=custom&pid=argos_app_exclusive&c=app-exclusive-oct2025-3063037&deep_link_value=product%2F3063037&af_dp=argos%3A%2F%2F&af_web_dp=http%3A%2F%2Fargos.co.uk%2Fevents%2Fargos-app%3Fcmpid%3Dappsflyer%26utm_source%3Donelink%26utm_campaign%3Dapp_exclusive'
}

export const isAppExclusiveSKU = sku => {
  const BRAND = process.env.BRAND || 'ARGOS'

  if (BRAND !== 'ARGOS') return false
  return Object.keys(appExclusiveSkus).includes(sku)
}

export const getAppExclusiveLink = sku => {
  return appExclusiveSkus[sku]
}
